// TODO: Issue MRP-2766
// eslint-disable-next-line import/no-named-as-default
import ApiHandler from "api/api-handler";
import { API_ROUTES } from "api/const";

const flagsApi = {
  getFlags: (params = {}) =>
    ApiHandler.get({
      url: API_ROUTES.FLAGS,
      params
    }),

};

export default flagsApi;